import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import Header from "../Header";
import host from "../../config";

// Define outside to prevent redefinition

const GurajadaKalakshetram = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  const pricingData = [
    {
      id: 1,
      purpose: "Government Schools (Cultural Activities)",
      rent: 10000,
      deposit: 5000,
      gst: 2700,
      cleaning: 5000,
      total: 27700,
    },
    {
      id: 2,
      purpose: "Private Schools / Colleges",
      rent: 50000,
      deposit: 30000,
      gst: 9900,
      cleaning: 5000,
      total: 94900,
    },
    {
      id: 3,
      purpose: "Cultural Programs (VUDA Jurisdiction)",
      rent: 10000,
      deposit: 20000,
      gst: 2700,
      cleaning: 5000,
      total: 37700,
    },
    {
      id: 4,
      purpose: "Weddings / Receptions / Private Events",
      rent: 150000,
      deposit: 50000,
      gst: 28800,
      cleaning: 10000,
      total: 238800,
    },
    {
      id: 5,
      purpose: "Religious Activities",
      rent: 50000,
      deposit: 30000,
      gst: 9900,
      cleaning: 5000,
      total: 94900,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.length > 0 ? (
              ImagesList.map((item, idx) => (
                <div key={idx} className="carousel-image">
                  <img src={item.url} alt={`Gurajada Image ${idx + 1}`} />
                  <div className="overlay">
                    <h1>Gurajada Kalakshetram</h1>
                    <p>Premier Cultural Venue in Vizag</p>
                  </div>
                </div>
              ))
            ) : (
              <p>Loading images...</p>
            )}
          </Carousel>
        </div>

        {/* Venue Details */}
        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Gurajada Kalakshetram</strong>, located at{" "}
            <strong>Siripuram Junction, Vizag</strong>, is a renowned cultural
            landmark, offering a platform for various events such as theatre
            performances, school celebrations, concerts, weddings, and private
            gatherings. Managed by <strong>VMRDA</strong>, this venue boasts
            modern amenities, including spacious seating, air-conditioned halls,
            and high-quality sound systems.
          </p>

          {/* Amenities Section */}
          <h3> Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Fully Air-conditioned Auditorium</li>
            <li>✅ Spacious Seating Capacity</li>
            <li>✅ Advanced Sound & Lighting System</li>
            <li>✅ Large Parking Area</li>
            <li>✅ Dedicated Backstage & Green Rooms</li>
          </ul>

          {/* Pricing Section */}
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Additional Charges */}
          <p className="note">
            <strong>Note:</strong> Electrical charges as consumed and sweeping
            charges of ₹5,000 + GST (18%) will be paid by the applicant to
            VMRDA.
          </p>

          {/* Contact Section */}
          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Siripuram Junction, Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@gurajadakalakshetram.com
            </p>
          </div>

          {/* Booking Button */}
          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GurajadaKalakshetram;
